import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=23108c06&scoped=true&"
import script from "./LayoutPage.vue?vue&type=script&lang=js&"
export * from "./LayoutPage.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=23108c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23108c06",
  null
  
)

export default component.exports